import AddIcon from "@mui/icons-material/Add";
import LayersIcon from "@mui/icons-material/Layers";
import HistoryIcon from "@mui/icons-material/History";

export const ITEMS = [
  { id: "new", label: "Nouvelle analyse", icon: <AddIcon fontSize="small" /> },
  { id: "layers", label: "Couches", icon: <LayersIcon fontSize="small" /> },
  {
    id: "analyses",
    label: "Historique des analyses",
    icon: <HistoryIcon fontSize="small" />,
  },
];
export const TABS = [
  { id: "area", label: "Surface (ha)" },
  { id: "co2", label: "CO₂ (t)" },
  { id: "buildings", label: "Bâtiments" },
];

export const IMPACTS_TABS = ["Impacts", "Coût des sauvés", "Rapport"];

export const SECTIONS = ["Statistiques", "Liste des analyses"];
